import Term from "../../term/Term";
import LearningContinue from "./LearningContinue";

export default class LearningContinueResult {
  terms: Term[];
  learningContinue: LearningContinue;

  constructor(terms: Term[], learningContinue: LearningContinue) {
    this.terms = terms;
    this.learningContinue = learningContinue;
  }

  static fromJson(json: any): LearningContinueResult {
    const itemSize: number = json.itemSize;
    const currentIndex: number = json.currentIndex;
    const currentPage: number = json.currentPage;
    const learningContinue = new LearningContinue(
      itemSize,
      currentIndex,
      currentPage
    );

    const termsJsonData = json.terms;
    if (termsJsonData === undefined)
      return new LearningContinueResult([], learningContinue);
    const terms = termsJsonData.map((termData: any) => Term.fromJson(termData));
    return new LearningContinueResult(terms, learningContinue);
  }
}
